import React from 'react';
import {
  UserPlus,
  FileText,
  Briefcase,
  DollarSign,
  Users,
  AlertTriangle,
  Award,
  GraduationCap,
  Calendar,
  XCircle,
  File,
  MoreHorizontal
} from 'lucide-react';

/**
 * Mapeo de categorías a iconos y colores
 */
const CATEGORY_CONFIG = {
  contratacion: {
    icon: UserPlus,
    color: 'blue',
    label: 'Contratación'
  },
  contractual: {
    icon: FileText,
    color: 'indigo',
    label: 'Contractual'
  },
  administrativo: {
    icon: Briefcase,
    color: 'gray',
    label: 'Administrativo'
  },
  salarial: {
    icon: DollarSign,
    color: 'green',
    label: 'Salarial'
  },
  organizacional: {
    icon: Users,
    color: 'purple',
    label: 'Organizacional'
  },
  disciplinario: {
    icon: AlertTriangle,
    color: 'red',
    label: 'Disciplinario'
  },
  reconocimiento: {
    icon: Award,
    color: 'yellow',
    label: 'Reconocimiento'
  },
  capacitacion: {
    icon: GraduationCap,
    color: 'teal',
    label: 'Capacitación'
  },
  ausencia: {
    icon: Calendar,
    color: 'orange',
    label: 'Ausencia'
  },
  terminacion: {
    icon: XCircle,
    color: 'gray',
    label: 'Terminación'
  },
  documento: {
    icon: File,
    color: 'pink',
    label: 'Documento'
  },
  otro: {
    icon: MoreHorizontal,
    color: 'gray',
    label: 'Otro'
  }
};

/**
 * Componente de ícono para categorías de eventos
 */
export default function EventCategoryIcon({ categoria, size = 20, showBackground = true, className = '' }) {
  const config = CATEGORY_CONFIG[categoria] || CATEGORY_CONFIG.otro;
  const Icon = config.icon;

  if (showBackground) {
    return (
      <div className={`w-10 h-10 rounded-lg flex items-center justify-center bg-${config.color}-50 ${className}`}>
        <Icon size={size} className={`text-${config.color}-600`} />
      </div>
    );
  }

  return <Icon size={size} className={`text-${config.color}-600 ${className}`} />;
}

/**
 * Obtener configuración de categoría
 */
export function getCategoryConfig(categoria) {
  return CATEGORY_CONFIG[categoria] || CATEGORY_CONFIG.otro;
}

/**
 * Obtener label de categoría
 */
export function getCategoryLabel(categoria) {
  const config = CATEGORY_CONFIG[categoria];
  return config ? config.label : 'Otro';
}
